var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-banner",class:[_vm.tone !== 'bad' && `ui-banner--${_vm.tone}`, _vm.lg && 'ui-banner--lg'],attrs:{"role":_vm.role}},[_c('v-icon',{attrs:{"size":"16","color":"currentColor"}},[_vm._v(_vm._s(_vm.iconName))]),_c('span',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }